import styled from "@emotion/styled";

export const CheckboxLabel = styled("label")`
    display: inline-flex;
    align-items: flex-start;
`;
